import { Crown } from "lucide-react";

const CALENDLY = "https://calendly.com/erodwentpro/rideshare-booking";

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-2xl bg-black/55 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo-link"
          className="flex items-center gap-2.5 group"
        >
          <Crown
            className="w-5 h-5 text-[#D4AF37] crown-shimmer"
            strokeWidth={1.5}
          />
          <span className="font-serif text-base sm:text-lg tracking-wide text-white">
            Royal Rides{" "}
            <span className="italic gold-text">Queen</span>
          </span>
        </a>
        <a
          href={CALENDLY}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-book-now-button"
          className="hidden sm:inline-flex items-center text-xs uppercase tracking-[0.22em] px-5 py-2.5 border border-[#D4AF37]/60 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#05030A] transition-all duration-300"
        >
          Book Now
        </a>
      </div>
    </header>
  );
};
